import React from 'react';
import Module from 'Components/Core/Module';
import './Polls.css';

export default function Polls(props) {

	const x = props.x;
	const [polls, setPolls] = React.useState([]);
	const [selected, setSelected] = React.useState({});

	function load() {
		x.was.axGet('Backend/webapp.php?module=Poll&task=GetPollResults', (result) => {
			if (result.data.returncode === 1) {
				setPolls(result.data.content);
			}
		});
	}

	// onShow (siehe unten) feuert nur bei einem erneuten Aktivieren NACH dem
	// ersten Mount - beim allerersten activate() ist x.wam[id].show() noch
	// die Platzhalter-Funktion aus WebappModule.js's init(id), nicht die
	// echte Funktion aus Module.js (die erst beim tatsaechlichen Rendern
	// dieser Komponente registriert wird). Ohne diesen Effekt bliebe die
	// Liste beim ersten Oeffnen leer, bis man das Modul verlaesst und wieder
	// aktiviert.
	React.useEffect(() => {
		load();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	function toggleOption(poll, optionId) {
		setSelected((current) => {
			const currentForPoll = current[poll.pollid] || [];
			let next;
			if (poll.ismultiplechoice) {
				next = currentForPoll.includes(optionId)
					? currentForPoll.filter((id) => id !== optionId)
					: [...currentForPoll, optionId];
			}
			else {
				next = [optionId];
			}
			return { ...current, [poll.pollid]: next };
		});
	}

	function vote(poll) {
		const optionIds = selected[poll.pollid] || [];
		if (optionIds.length === 0) return;
		x.was.axPost('Backend/webapp.php?module=Poll&task=Vote', { optionIds }, (result) => {
			if (result.data.returncode === 1) {
				load();
			}
			else {
				x.wah.addHint('Abstimmen fehlgeschlagen.', true);
			}
		});
	}

	function renderPoll(poll) {
		const canVote = !poll.isclosed && !poll.hasvoted;
		const totalVotes = poll.resultsvisible
			? poll.options.reduce((sum, o) => sum + (o.votecount || 0), 0)
			: 0;

		return (
			<div key={poll.pollid} className="poll-card">
				<div className="poll-question">{poll.question}</div>
				<div className="poll-options">
					{poll.options.map((option) => {
						const isSelected = (selected[poll.pollid] || []).includes(option.optionid);
						const percent = (poll.resultsvisible && totalVotes > 0)
							? Math.round((option.votecount / totalVotes) * 100)
							: null;
						return (
							<label key={option.optionid} className={`poll-option ${canVote ? 'poll-option-votable' : ''}`}>
								{canVote &&
									<input
										type={poll.ismultiplechoice ? 'checkbox' : 'radio'}
										name={'poll-' + poll.pollid}
										checked={isSelected}
										onChange={() => toggleOption(poll, option.optionid)}
									/>
								}
								<span className="poll-option-text">{option.optiontext}</span>
								{percent !== null &&
									<span className="poll-option-result">
										<span className="poll-option-bar" style={{ width: percent + '%' }} />
										<span className="poll-option-percent">{percent}% ({option.votecount})</span>
									</span>
								}
							</label>
						);
					})}
				</div>
				{canVote &&
					<button className="btn poll-vote-button" type="button" onClick={() => vote(poll)} disabled={(selected[poll.pollid] || []).length === 0}>
						Abstimmen
					</button>
				}
				{!!poll.hasvoted && !poll.resultsvisible &&
					<div className="poll-status-hint">Danke für deine Teilnahme. Ergebnis wird nach Schließung angezeigt.</div>
				}
				{!!poll.isclosed &&
					<div className="poll-status-hint">Umfrage geschlossen.</div>
				}
			</div>
		);
	}

	return (
		<Module id={props.id} x={x} classes="module-polls" title={props.title} display={props.display} onShow={load}>
			{polls.length === 0
				? <div className="poll-empty">Keine Umfragen vorhanden.</div>
				: polls.map(renderPoll)
			}
		</Module>
	)

};
